import { HTTPError } from 'ky';

export interface ApiError {
  status: number;
  title: string;
  detail?: string;
  fieldErrors?: Record<string, string[]>;
}

export async function toApiError(err: unknown): Promise<ApiError> {
  if (err instanceof HTTPError) {
    try {
      // Geklont: derselbe Fehler wird mehrfach gelesen (StrictMode, erneutes Einhängen), und ein
      // Body lässt sich nur einmal lesen — beim zweiten Mal ginge der Grund des Servers verloren.
      const body = (await err.response.clone().json()) as {
        title?: string;
        detail?: string;
        errors?: Record<string, string[]>;
      };
      return {
        status: err.response.status,
        title: body.title ?? err.message,
        ...(body.detail !== undefined ? { detail: body.detail } : {}),
        ...(body.errors !== undefined ? { fieldErrors: body.errors } : {}),
      };
    } catch {
      return { status: err.response.status, title: err.message };
    }
  }
  return { status: 0, title: err instanceof Error ? err.message : 'Unbekannter Fehler' };
}
